<script lang="typescript">
  import WordRow from './WordRow.svelte'
  import { dict } from './dict'

  interface Row {
    size: number
    space: number
  }

  type GuessEvent = CustomEvent<{
    guess: string
    offset: number
    scoreElement: HTMLElement
  }>

  export let word: string = ''

  let answer: string = '?'.repeat(word.length)
  let score: number = 0
  let rows: Row[] = generateRows()
  let currentRow: number = 0
  let restartWording: string = 'Restart'

  function generateRows(): Row[] {
    let rows: Row[] = []
    let goingForward = true
    rows.push({ space: 0, size: 2 })
    for (let len = 3; len < word.length; len++) {
      for (
        let offset = goingForward ? 0 : word.length - len;
        goingForward ? (offset + len <= word.length) : (offset >= 0);
        offset += goingForward ? 1 : -1
      ) {
        rows.push({ space: offset, size: len })
      }
      goingForward = !goingForward
    }
    rows.push({ space: 0, size: word.length })
    return rows
  }

  function isValid(guess: string): boolean {
    for (const word of dict) {
      if (guess.toLowerCase() === word) {
        return true
      }
    }
    return false
  }

  function restartGame(event: Event) {
    event.preventDefault()
    window.location.reload(false)
  }

  function scoreGuess(guess: string, answer: string, offset: number = 0) {
    guess = ' '.repeat(offset) + guess // pad with spaces to align with answer
    return Array.from(guess).reduce((score, letter, i) => {
      if (answer[i] === letter) {
        score += 1000
      } else if (answer.includes(letter)) {
        score += 250
      }
      return score
    }, 0)
  }

  function submitWord(event: GuessEvent) {
    const guess = event.detail.guess

    // Check that the entered word is valid (i.e. filled out and an actual word).
    if (!isValid(guess)) {
      window.alert(`"${guess}" is not a valid word`)
      return
    }

    // Update the scores.
    const wordScore = scoreGuess(guess, word, event.detail.offset)
    score += wordScore
    event.detail.scoreElement.innerText = String(wordScore)

    // Go to the next row.
    currentRow++

    // Finish the game if we're at the end.
    if (currentRow === rows.length) {
      answer = word // reveal answer
      restartWording = 'Play Again'
    }
  }
</script>

<form on:reset={restartGame}>
  <table>
    <WordRow value={answer} leftSpace={0} readonly={true} {score}/>
    {#each rows as row, i}
      <WordRow value={' '.repeat(row.size)} row={i} leftSpace={row.space} rightSpace={Math.max(0, word.length - row.size - row.space)} focus={currentRow === i} readonly={currentRow !== i} on:submitWord={submitWord}/>
    {/each}
  </table>
  <input type="reset" value={restartWording} />
</form>

<style>
</style>
